export const states = {
  India: {
    code: "IN",
    states: [
      "Maharashtra",
      "Gujrat",
      "Madhya Pradesh",
      "West Bengal",
      "Bihar",
      "Rajasthan",
      "Andhra Pradesh",
      "Karnataka",
      "Tamil Nadu",
      "Uttar Pradesh",
      "New Delhi",
    ],
  },
  Russia: {
    code: "RU",
    states: ["Crimea", "Kalmykia", "Komi", "Altai", "Buryatia", "Chechnya"],
  },
};

export const countries = Object.keys(states);
